import React from 'react';

import type { TReviewsContext } from '../../types/TReviewsContext';

export const ReviewsContext = React.createContext({} as TReviewsContext);
